import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortTime' })
export class ShortTimePipe implements PipeTransform {
	transform(value: string): string {
		const splited: string[] = value.split(':');
		return splited[0] + ':' + splited[1];
	}
}
